/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-12 11:03.
 */
const ImgUpload = {
  getFileSize( e ) {
    const obj = {};
    obj.name = e.target.files[ 0 ].name;
    obj.size = ( e.target.files[ 0 ].size / 1024 / 1024 ).toFixed( 1 );
    return obj;
  },
  genImg( item ) {
    const { url, type = '', original = '', size = 0 } = item;
    if (url) {
      const html = `
        <div class="upload-certificate-preview upload-certificate-item">
          <div class="img-mask">
            <span class="delete-img"><i class="icon iconfont icon-Shape"></i></span>
          </div>
          <img src="${ url }" alt="" data-suffix="${ type }" data-name="${ original }" data-size="${ size }">
        </div>`;
      return html;
    }
  }
};

module.exports = ImgUpload;
